import styled from "styled-components";
import { sm } from "../../../AppTheme.styled";

const HR = styled.hr<{ vertical?: boolean }>`
  background-color: ${(props) => props.theme.palette.neutral4};
  display: block;
  border: none;
  height: 1px;
  width: 100%;
  margin: 16px 0;

  ${sm} {
    height: ${(props) => (props.vertical ? "auto" : "1px")};
    width: ${(props) => (props.vertical ? "1px" : "100%")};
    margin: ${(props) => (props.vertical ? "0 32px" : "16px 0")};
  }
`;

export default HR;
